const _excluded = ["passwordConfirm"];function _extends() {_extends = Object.assign ? Object.assign.bind() : function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};return _extends.apply(this, arguments);}function ownKeys(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}function _objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {_defineProperty(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}function _defineProperty(obj, key, value) {key = _toPropertyKey(key);if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}function _toPropertyKey(arg) {var key = _toPrimitive(arg, "string");return typeof key === "symbol" ? key : String(key);}function _toPrimitive(input, hint) {if (typeof input !== "object" || input === null) return input;var prim = input[Symbol.toPrimitive];if (prim !== undefined) {var res = prim.call(input, hint || "default");if (typeof res !== "object") return res;throw new TypeError("@@toPrimitive must return a primitive value.");}return (hint === "string" ? String : Number)(input);}var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}function _objectWithoutProperties(source, excluded) {if (source == null) return {};var target = _objectWithoutPropertiesLoose(source, excluded);var key, i;if (Object.getOwnPropertySymbols) {var sourceSymbolKeys = Object.getOwnPropertySymbols(source);for (i = 0; i < sourceSymbolKeys.length; i++) {key = sourceSymbolKeys[i];if (excluded.indexOf(key) >= 0) continue;if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;target[key] = source[key];}}return target;}function _objectWithoutPropertiesLoose(source, excluded) {if (source == null) return {};var target = {};var sourceKeys = Object.keys(source);var key, i;for (i = 0; i < sourceKeys.length; i++) {key = sourceKeys[i];if (excluded.indexOf(key) >= 0) continue;target[key] = source[key];}return target;} /* eslint-disable react/jsx-props-no-spreading */
import React, { useEffect, useState } from 'react';

import { RequestParams } from "../../../../utils/RequestParams";
import UsersAPI from "../../../../Users/UsersAPI";


import { useLoaderData, useRevalidator } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { useSetRecoilState } from 'recoil';
import { notificationAtom } from "../../../atoms";

import { InputField } from "../../../Components/Forms";
import { Button, Card, Sidepanel } from "../../../Components/UI";
import { SettingsContent } from "../../../Components/Layouts/SettingsContent";
import { Translate } from "../../../../I18N";
import { TwoFactorSetup } from "./Components/TwoFactorSetup";

const accountLoader =
(headers) =>
async () =>
UsersAPI.currentUser(new RequestParams({}, headers));

const Account = () => {
  const userAccount = useLoaderData();
  const [isSidepanelOpen, setIsSidepanelOpen] = useState(false);
  const setNotifications = useSetRecoilState(notificationAtom);
  const revalidator = useRevalidator();


  const {
    register,
    watch,
    handleSubmit,
    reset,
    formState: { errors, isSubmitted }
  } = useForm({
    defaultValues: userAccount,
    mode: 'onSubmit'
  });

  const submit = async (data) => {
    const { passwordConfirm } = data,userData = _objectWithoutProperties(data, _excluded);
    userData.password = userData.password ? userData.password : userAccount.password;
    await UsersAPI.save(new RequestParams(userData));
    await revalidator.revalidate();
    setNotifications({
      type: 'success',
      text: /*#__PURE__*/_jsx(Translate, {}, void 0, "Account updated")
    });
  };

  useEffect(() => {
    reset(_objectSpread(_objectSpread({}, userAccount), {}, { password: '', passwordConfirm: '' }));
  }, [userAccount, reset]);

  return /*#__PURE__*/(
    _jsx("div", {
      className: "tw-content",
      style: { width: '100%', overflowY: 'auto' },
      "data-testid": "settings-account" }, void 0, /*#__PURE__*/

    _jsx(SettingsContent, {}, void 0, /*#__PURE__*/
    _jsx(SettingsContent.Header, { title: "Account" }), /*#__PURE__*/
    _jsx(SettingsContent.Body, {}, void 0, /*#__PURE__*/
    _jsx("form", { onSubmit: handleSubmit(submit), id: "account-form" }, void 0, /*#__PURE__*/
    _jsx(Card, { className: "mb-4", title: /*#__PURE__*/_jsx(Translate, {}, void 0, "General Information") }, void 0, /*#__PURE__*/
    _jsx("div", { className: "grid gap-4 sm:grid-cols-2 sm:gap-6" }, void 0, /*#__PURE__*/
    _jsx("div", { className: "sm:col-span-1" }, void 0, /*#__PURE__*/
    _jsx(InputField, {
      id: "account-username",
      label: /*#__PURE__*/_jsx(Translate, {}, void 0, "Username"),
      value: userAccount.username,
      disabled: true }
    )
    ), /*#__PURE__*/
    _jsx("div", { className: "sm:col-span-1" }, void 0, /*#__PURE__*/
    _jsx(InputField, {
      id: "account-role",
      label: /*#__PURE__*/_jsx(Translate, {}, void 0, "User Role"),
      value: userAccount.role,
      disabled: true }
    )
    ), /*#__PURE__*/
    _jsx("div", { className: "col-span-2" }, void 0, /*#__PURE__*/
    React.createElement(InputField, _extends({
      id: "account-email",
      hasErrors: !!errors.email,
      label: /*#__PURE__*/_jsx(Translate, {}, void 0, "Email") },
    register('email', { required: true }))
    )
    )
    )
    ), /*#__PURE__*/
    _jsx(Card, { className: "mb-4", title: /*#__PURE__*/_jsx(Translate, {}, void 0, "Change Password") }, void 0, /*#__PURE__*/
    _jsx("div", { className: "grid gap-4 sm:grid-cols-2 sm:gap-6" }, void 0, /*#__PURE__*/
    _jsx("div", { className: "sm:col-span-1" }, void 0, /*#__PURE__*/
    React.createElement(InputField, _extends({
      id: "new-password",
      hasErrors: !!errors.passwordConfirm,
      label: /*#__PURE__*/_jsx(Translate, {}, void 0, "New Password") },
    register('password'), {
      type: "password" })
    ),
    errors.passwordConfirm && isSubmitted && /*#__PURE__*/
    _jsx("p", { className: "mt-2 text-sm text-error-600" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Passwords do not match")
    )

    ), /*#__PURE__*/
    _jsx("div", { className: "sm:col-span-1" }, void 0, /*#__PURE__*/
    React.createElement(InputField, _extends({
      id: "confirm-new-password",
      hasErrors: !!errors.passwordConfirm,
      label: /*#__PURE__*/_jsx(Translate, {}, void 0, "Confirm New Passowrd") },
    register('passwordConfirm', { validate: (val) => val === watch('password') }), {
      type: "password" })
    )
    )
    )
    ),
    userAccount.using2fa ? /*#__PURE__*/
    _jsx(Card, {
      className: "mb-4",
      title: /*#__PURE__*/_jsx(Translate, {}, void 0, "Two-Factor Authentication"),
      color: "default" }, void 0, /*#__PURE__*/

    _jsx("div", { className: "flex items-center gap-6" }, void 0, /*#__PURE__*/
    _jsx(Button, { color: "success", disabled: true, className: "flex-none" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Activated")
    ), /*#__PURE__*/
    _jsx("div", { className: "flex-1 grow" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Your account's security is enhanced with two-factor authentication."

    )
    )
    )
    ) : /*#__PURE__*/

    _jsx(Card, {
      className: "mb-4",
      title: /*#__PURE__*/_jsx(Translate, {}, void 0, "Two-Factor Authentication"),
      color: "yellow" }, void 0, /*#__PURE__*/

    _jsx("div", { className: "flex items-center gap-6" }, void 0, /*#__PURE__*/
    _jsx(Button, {
      styling: "outline",
      className: "flex-none",
      onClick: () => setIsSidepanelOpen(true) }, void 0, /*#__PURE__*/

    _jsx(Translate, {}, void 0, "Enable")
    ), /*#__PURE__*/
    _jsx("div", { className: "flex-1 grow" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "You should activate this feature for enhanced account security."

    )
    )
    )
    )

    )
    ), /*#__PURE__*/
    _jsx(SettingsContent.Footer, {}, void 0, /*#__PURE__*/
    _jsx("div", { className: "flex gap-2" }, void 0, /*#__PURE__*/
    _jsx("a", {
      href: "/logout",
      "data-testid": "account-logout",
      className: "px-3 py-2 text-xs font-medium bg-white border rounded-lg hover:text-white text-error-700 border-error-700 hover:bg-error-800 hover:border-error-800 focus:outline-none focus:ring-4 focus:ring-indigo-200" }, void 0, /*#__PURE__*/

    _jsx(Translate, {}, void 0, "Logout")
    ), /*#__PURE__*/

    _jsx(Button, { type: "submit", form: "account-form" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Update")
    )
    )
    )
    ), /*#__PURE__*/
    _jsx(Sidepanel, {
      title: /*#__PURE__*/_jsx(Translate, { className: "uppercase" }, void 0, "Two-Factor Authentication"),
      isOpen: isSidepanelOpen,
      closeSidepanelFunction: () => setIsSidepanelOpen(false),
      size: "large",
      withOverlay: true }, void 0, /*#__PURE__*/

    _jsx(TwoFactorSetup, { closePanel: () => setIsSidepanelOpen(false) })
    )
    ));

};

export { Account, accountLoader };